<template>
  <div class="portal-header">
    <div class="rt-header__main" v-if="title || $slot.toolbar">
      <h1 class="rt-header__title">
        <span>{{title}}</span>
      </h1>
      <div class="rt-header__action">
        <slot name="toolbar"></slot>
        <slot name="mainbtn"></slot>
        <el-button v-if="showBack" plain size="small" @click="goBack()" style="margin-left:20px;width:60px;height:30px" >{{$tx('返回','common.return')}}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "RtHeader",
  props: {
    title: {
      type: String,
      default: "",
      required: true,
    },
     slotBack:{
       type:Boolean,
       default:false
     },
     showBack:{
       type:Boolean,
       default:true
     }
  },
  methods: {
    goBack() {
      if(this.slotBack){
        this.$emit("go-back");
      }else{
        this.$router.back();
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// main.vue?ad505372